import { render, staticRenderFns } from "./ClimateHazardsMediumToExtremeChartTest.vue?vue&type=template&id=36ee2f4f&scoped=true&"
import script from "./ClimateHazardsMediumToExtremeChartTest.vue?vue&type=script&lang=js&"
export * from "./ClimateHazardsMediumToExtremeChartTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ee2f4f",
  null
  
)

export default component.exports